const formatter = new Intl.NumberFormat("es-EC", {
  style: "currency",
  currency: "USD",
  minimumFractionDigits: 0,
});

export const formatCurrency = (value) => formatter.format(value || 0);

export const mapKpis = (kpis) =>
  (kpis || []).map((kpi) => ({
    ...kpi,
    value: kpi.value,
  }));

export const mapCobranza = (data) => {
  const avance = data.objetivo ? Math.min((data.totalMes / data.objetivo) * 100, 130) : 0;
  return {
    ...data,
    avance,
    totalFmt: formatCurrency(data.totalMes),
    objetivoFmt: formatCurrency(data.objetivo),
    topDeudores: data.topDeudores || [],
  };
};

export const mapContratos = (data) => {
  const total = (data.generados || 0) + (data.pendientes || 0);
  const progreso = total ? Math.round(((data.generados || 0) / total) * 100) : 0;
  return {
    ...data,
    total,
    progreso,
  };
};

export const mapPromociones = (list) =>
  (list || []).map((item) => {
    const capacidad = item.capacidad || 0;
    const ocupacion = item.ocupacion || 0;
    const porcentaje = capacidad ? Math.min(Math.round((ocupacion / capacidad) * 100), 130) : 0;
    return { ...item, porcentaje };
  });
